const Footer = () => {
  return (
    <div className="footer">
      <p className="text-center">
        Dota 2, and the Dota 2 logo are registered trademarks of{" "}
        <a
          href="https://www.valvesoftware.com/en/"
          className="text-decoration-none"
          rel="noopener noreferrer"
          target="_blank"
        >
          Valve Corporation.
        </a>
      </p>
      <p className="text-center m-0">
        This site uses{" "}
        <a
          href="https://www.opendota.com/"
          className="text-decoration-none"
          rel="noopener noreferrer"
          target="_blank"
        >
          OpenDota's API
        </a>
      </p>
    </div>
  );
};

export default Footer;
